/* eslint-disable react/jsx-no-bind */
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import logo from '../../assets/sc_logo_comp.png';
import { STORAGE_KEYS } from '../../constants/storageKeys';

import loginService from './loginService';

import '../../custom.scss';
import './index.scss';

const Login = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState('');
  const [showPassword, setShowPassword] = useState(false); // 👁️ toggle state

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const newErrors = {};
    if (!credentials.username.trim())
      newErrors.username = 'Username is required';
    if (!credentials.password.trim())
      newErrors.password = 'Password is required';
    else if (credentials.password.length < 6)
      newErrors.password = 'Password must be at least 6 characters';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setApiError('');

    try {
      const data = await loginService.userLogin({
        username: credentials.username,
        password: credentials.password,
      });

      sessionStorage.setItem(STORAGE_KEYS.TOKEN, data.access_token);
      const refreshTokenValue = data.refresh_token;
      if (refreshTokenValue) {
        sessionStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshTokenValue);
      }
      navigate('/booking-intelligence');
    } catch (error) {
      setApiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row d-flex">
        <div className="col-md-8 logo-container d-none d-md-flex">
          <img
            src={logo}
            width={500}
            className="logo-image"
            loading="lazy"
            alt="Logo"
          />
        </div>
        <div className="col-12 logo-container d-md-none">
          <img
            src={logo}
            width={500}
            className="logo-image"
            loading="lazy"
            alt="Logo"
          />
        </div>
        <div className="col-md-4 login-wrapper">
          <div className="login-container">
            <form onSubmit={handleSubmit}>
              {/* Username Field */}
              <div className="form-group">
                <label htmlFor="username">Email</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={credentials.username}
                  onChange={handleChange}
                  className={errors.username ? 'input-error' : ''}
                />
                {errors.username && (
                  <span className="error-message">{errors.username}</span>
                )}
              </div>

              {/* Password Field with Eye Icon */}
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    value={credentials.password}
                    onChange={handleChange}
                    className={errors.password ? 'input-error' : ''}
                    style={{ width: '100%', paddingRight: '40px' }}
                  />
                  <IconButton
                    onClick={() => setShowPassword((prev) => !prev)}
                    aria-label={
                      showPassword ? 'Hide password' : 'Show password'
                    }
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      padding: 0,
                      color: '#555',
                      width: '0px',
                    }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </div>
                {errors.password && (
                  <span className="error-message">{errors.password}</span>
                )}
              </div>

              {/* API Error Message */}
              {apiError && <div className="api-error-message">{apiError}</div>}

              {/* Submit Button */}
              <button
                type="submit"
                disabled={loading}
                className="login-button"
                style={{ width: '100%', padding: '18px' }}
              >
                {loading ? 'Logging in...' : 'Login'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
